<template>
  <div id="subtitle">
    <div id="top-toolbar">
      <TitleToolbar />
    </div>
    <div id="bottom-main">
      <div id="left-area">
        <div id="edit-canvas-area">
          <CanvasContainer></CanvasContainer>
        </div>
        <div id="timeline-area">
          <TimelineSubtitle />
        </div>
      </div>
      <div id="right-area">
        <SubtitlePanel />
      </div>
    </div>

    <SubtitleQuickMenu></SubtitleQuickMenu>
    <SubtitleExport v-if="isShowExport" />
    <SubtitleMessageDialog></SubtitleMessageDialog>
    <SubtitlePopups />
    <Guidance />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TimelineSubtitle from "./components/subtitle/timeline";
import TitleToolbar from "./components/subtitle/titleToolbar/titleToolbar";
import SubtitleQuickMenu from "./components/subtitle/quickMenu/subtitleQuickMenu";
import SubtitleNav from "./components/subtitle/subtitleNav";
import SubtitlePanel from "./components/subtitle/subtitlePanel";
import EditToolbar from "./components/subtitle/videoEditToolbar";
import SubtitleExport from "./components/subtitle/subtitleExport";
import CanvasContainer from "./components/subtitle/editCanvas/canvasContainer";
import SubtitleMessageDialog from "./components/SubtitleMessageDialog";
import SubtitlePopups from "./components/subtitle/subtitlePopups";
import Keyboard from "./components/subtitle/keyboard";
import Guidance from "./components/subtitle/subtitleGuidanceOld";

export default {
  data () {
    return {};
  },
  mixins: [Keyboard],
  computed: {
    ...mapGetters({
      isShowExport: "subtitleExport/isShowExport"
    }),
    ...mapGetters([
      'downFonts'
    ])
  },
  created () {
    this.downFonts.forEach(font => this.loadFonts(font.value));
    this.getCheckFont();
  },
  mounted () {
    setInterval(() => {
      let div = document.getElementsByClassName("pace  pace-inactive")[0];
      if (div) div.style.display = "none";
    }, 700);

    this.upDataUserMsg();
  },
  methods: {
    upDataUserMsg () {
      if (!this.$route.subtitle) return;
      this.$http.get("/api/session").then(res => {
        // 请求用户数据
        let { data: resData } = res.data;

        this.$store.commit("save_UserId", resData.id);

        // 临时体验会员
        // if (resData.tmpLevelType != null && resData.tmpLevelType > 1) {
        //   resData.level = resData.tmpLevel;
        //   resData.levelType = resData.tmpLevelType;
        // }

        // if (resData.tmpLevelType != null && resData.tmpLevelType === 0) {
        //   resData.levelType = 0;
        //   resData.level = resData.tmpLevel;
        // }

        this.$store.commit("toggle_UserMsg", resData);
        this.$bus.emit("upDataUserMsg_vue_done");
      });
    },
    loadFonts (font) {
      let _this = this;
      // 下载字体
      fetch(this.$handleAssetsUrl(font)).then(function (res) {
        if (!res.ok) console.error('load font "' + font + '" fail:', res);
        // 添加font-face
        var style =
          '<style type="text/css">\n' +
          "@font-face {" +
          'font-family: "' +
          font.split("/").pop() +
          '";' +
          'src: url("' +
          res.url +
          '");';
        var visualDom = "<div>来画动画</div>";
        $("head").prepend(style);
        $(visualDom)
          .appendTo($("body"))
          .css({
            fontFamily: `"${font.split("/").pop()}"`,
            visibility: "hidden",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -10
          });
        return Promise.resolve();
      });
    },
    getCheckFont (toolFont = []) {
      let downFonts = [];
      let downFont = null;
      let getDelayTime = function (time) {
        if (!time) return;
        let now = new Date(time * 1000);
        let fu = now.setFullYear(now.getFullYear() + 1);
        fu = new Date(fu).toISOString();
        fu = fu.split(/-|T/);
        fu.length = 3;
        return fu.join(".");
      };
      toolFont.unshift(this.downFonts[1].value);
      toolFont.unshift(this.downFonts[0].value);

      this.$http.get("/api/user/brand/font").then(res => {
        if (res.status === 200 && res.data.code === 200 && res.data.data) {
          let data = res.data.data;
          let textOption = {}
          for (let k in data) {
            if (k === 'title' || k === 'subtitle' || k === 'content') {
              let title = data[k];
              this.loadFonts(title.font.url);
              toolFont.push(title.font.url);
              textOption[k] = {
                fontId: title.font.id,
                font: {
                  fontFamilyUrl: title.font.url,
                  fontSize: title.size || 80,
                  color: title.color || '#303233',
                  fontWeight: title.blod === 0 ? 'normal' : 'bold',
                  fontStyle: title.italic === 0 ? 'normal' : 'italic',
                  textDecoration: title.underline === 0 ? 'none' : 'underline'
                }
              }
            }
            if (k === 'fontList') {
              let brandList = [];
              data[k].forEach(v => {
                brandList.push({
                  id: v.id,
                  value: v.url,
                  label: v.title,
                  fontUrl: v.fontUrl
                })
              })
              this.$store.commit("toggle_brandList", brandList);
            }
          }
          this.$store.commit("toggle_textOption", textOption);
        }

        toolFont = [...new Set(toolFont)];

        this.$http
          .get(
            "/api/common/material?style=1&type=6&sOfPage=199&fPage=199&pIndex=1"
          )
          .then(res => {
            if (res.data.data) {
              toolFont.forEach(item => {
                for (let i in res.data.data) {
                  downFont = res.data.data[i];
                  if (item === downFont.url) {
                    downFonts.push({
                      id: downFont.id,
                      value: downFont.url,
                      fontUrl: downFont.fontUrl,
                      label: downFont.title,
                      payType: downFont.payType,
                      isPay: downFont.tt ? true : false,
                      price: downFont.price,
                      delayTime:
                        downFont.tt && getDelayTime(downFont.tt.createTime),
                      status: 2
                    });
                    break;
                  }
                }
              });
              this.$store.commit("toggle_downFonts", downFonts);
            }
          });
      }).catch(err => {
        console.error(err)
      })
    }
  },
  components: {
    TimelineSubtitle,
    SubtitleNav,
    SubtitlePanel,
    TitleToolbar,
    SubtitleQuickMenu,
    EditToolbar,
    SubtitleExport,
    CanvasContainer,
    SubtitleMessageDialog,
    SubtitlePopups,
    Keyboard,
    Guidance
  }
};
</script>

<style lang="scss">
@import './src/style/icons';
</style>
<style lang="scss" scoped>
#subtitle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: transparent;
  z-index: 10;
  display: flex;
  flex-direction: column;
  #top-toolbar {
    position: relative;
    height: 60px;
    width: 100%;
    background-color: burlywood;
  }
  #bottom-main {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: transparent;
    display: flex;
    flex-direction: row;
    #left-area {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      #edit-canvas-area {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: transparent;
      }
      #timeline-area {
        background-color: cornflowerblue;
        width: 100%;
        height: 180px;
        flex-shrink: 0;
      }
    }
    #right-area {
      height: 100%;
      width: 246px;
      background-color: chocolate;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/VideoSubtitle.vue